import React from "react";
import Navbar from "../components/navbar";
import Footur from "../components/footur";
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Navbar />
      <div className="flex justify-center py-4 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-[90%] sm:max-w-4xl bg-white rounded-2xl p-4 sm:p-6">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1E90FF] flex items-center justify-center gap-2">
            LeadGenPro.in Privacy Policy
          </h1>
          <br></br>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF]">
            1️⃣ Introduction
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              {" "}
              At LeadGenPro.in, we respect your privacy and are committed to
              protecting your personal information. This Privacy Policy explains
              how we collect, use, and safeguard your information when you use
              our website for motor insurance lead generation.
            </li>
            <br></br>
            <li>
              The Partner agrees to abide by the laws, rules, and regulations
              applicable under the Insurance Act, 1938, IRDAI Guidelines, and
              Income Tax Act, 1961.
            </li>
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            2️⃣ What information we collect
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
              <b>Pro Lead Partners:</b>
              When you register as a Pro Lead partner, we collect your name,
              email address, and phone number.
            </li>

            <li>
              <b>Leads:</b>
              Leads: When you, as a Pro Lead Partner, submit a lead, we collect
              the lead's name, email address, phone number, vehicle details
              (such as make, model, and year), and potenƟ ally other information
              relevant to obtaining a motor insurance quote.
            </li>
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            3️⃣ How we use your information
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
            <b>Lead Genertion:</b>
            We use your information, and the information you provide about leads, to 
            generate motor insurance leads and connect you with potential customers.
            </li>
            <li>
            <b>Communication :</b>
            We may use your information to contact you, provide updates, respond to 
            your inquiries, and send you important information about our services.
            </li>
            <li>
            <b>Service Improvement :</b>
            We may use your information to improve our services, analyze trends, 
            and enhance your experience on our website
            </li>
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            4️⃣Data Security
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
            We take reasonable steps to protect your information. We use industry-standard security measures to 
            protect your information from unauthorized access, use, or disclosure.
            </li>
            
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            5️⃣ Data Sharing
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
        
            <li>
            We may share your information and lead information with insurance companies in order to generate 
quotes and facilitate the purchase of insurance policies. We will only share information that is 
necessary for this purpose. We will not sell your information to third parties
            </li>
            
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            6️⃣ Customer Rights
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
            You have the right to access, correct, or delete your information. You can request to update or delete 
your information by contacƟ ng us at support@leadgenpro.co.in. Leads also have the right to access 
or delete their information by contacƟ ng us or the relevant insurance company
            </li>
            
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            7️⃣Cookies & Policies
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
            Our website may use cookies to improve your browsing experience and personalize content. You can 
            adjust your browser settings to manage cookies.
            </li>
            
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            8️⃣  Contact Information
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
            If you have any questions or concerns about this Privacy Policy, please contact us at: 
            Support@leadgenpro.co.in
            </li>
            
          </ul>

          <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            9️⃣  Changes to Policy
          </h2>
          <ul className="list-disc pl-5 text-gray-700">
            <li>
            We may update this Privacy Policy from time to time. Any changes will be posted on our website.
            </li>
          
          </ul>
          
        </div>
      </div>
      </div>
  );
};

export default PrivacyPolicy;
